import React from 'react'
import { TriggerPipelineOnOperationExecute, useForm } from '@morningtrain/react-resources'
import { NestedAsyncPipeline, Pipeline } from '@morningtrain/react-helpers'
import OrderItemsToEnvOnPipe from 'widgets/inventory/OrderItemsToEnvOnPipe'
import DetermineDeliveryDatesOnPipe from 'widgets/inventory/DetermineDeliveryDatesOnPipe'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import OrderOverviewSmartview from 'widgets/smartviews/inventory/OrderOverviewSmartview'
import SelectDepartmentFromModelOnPipe from 'support/pipelines/pipes/SelectDepartmentFromModelOnPipe'
import { ConditionalNestedPipeline } from '@morningtrain/react-pipelines'
import DeliveryNoteOverviewSmartview from 'widgets/smartviews/inventory/DeliveryNoteOverviewSmartview'

export default function OnOrderReadPipeline () {
  const form = useForm()

  return (
    <Pipeline>
      <TriggerPipelineOnOperationExecute />
      <NestedAsyncPipeline>
        <OrderItemsToEnvOnPipe />
        <DetermineDeliveryDatesOnPipe />
        <SelectDepartmentFromModelOnPipe />
      </NestedAsyncPipeline>
      <ConditionalNestedPipeline when='data.model.status' matches={s => ['completed', 'received'].includes(s) === false}>
        <MountSmartviewWithModelOnPipe smartview={<OrderOverviewSmartview formRef={form} />} />
      </ConditionalNestedPipeline>
      <ConditionalNestedPipeline when='data.model.status' matches={s => ['completed', 'received'].includes(s)}>
        <MountSmartviewWithModelOnPipe smartview={<DeliveryNoteOverviewSmartview formRef={form} />} />
      </ConditionalNestedPipeline>
    </Pipeline>
  )
}
